import React from 'react';
import { Route } from 'react-router';

import {
  LoadableStripeConnectLanding,
  LoadableStripeConnectSuccess,
} from './helpers/loadables';

export default (
  <>
    {/* Stripe Connect Accounts */}
    <Route
      path="/stripe/connect-account"
      component={LoadableStripeConnectLanding}
    />
    <Route
      path="/stripe/connect-success"
      component={LoadableStripeConnectSuccess}
    />
  </>
);
